import { useEffect, useState } from "react";
import {LoadingAnimation} from "../../utils/loading_animation";

interface ChatbotLoadingMessageProps {
    statusMessage: string;
    addTopPadding: boolean;
}

export default function ChatbotLoadingMessage({ statusMessage, addTopPadding }: ChatbotLoadingMessageProps) {
    const [oldMessage, setOldMessage] = useState("");
    const [newMessage, setNewMessage] = useState("");
    useEffect(() => {
        let timeout = setTimeout(() => {
            setOldMessage("");
        }, 250);
        setOldMessage(newMessage);

        setNewMessage(statusMessage);
        return () => {
            clearTimeout(timeout);
        };
    }, [statusMessage]);

    return (
        <div className={`text-gray-800 fadeIn flex items-start gap-5 pb-3 ${addTopPadding ? "pt-4" : ""}`}>
            <div className="pt-3 w-6 h-6">
                <img
                    src="/chatbot-black.svg"
                    alt="user" className="w-full flex-shrink-0" />
            </div>
            <div
                className="bg-gray-500 italic text-white p-4 rounded-r-xl rounded-bl-xl shadow-lg w-full flex gap-4">
                <LoadingAnimation/>
                <div className="relative w-full h-6 text-base overflow-hidden">
                    <div className="fadeOutTop absolute" key={oldMessage}>{oldMessage}</div>
                    {(newMessage !== oldMessage) && <div className="fadeInBottom absolute" key={newMessage}>{newMessage}</div>}
                </div>
            </div>
        </div>
    );
}